export const TEXTS = {
  PAGE_TITLE: 'Отчёты',
  TAB_AUDIO: 'Аудиореклама',
  TAB_VIDEO: 'Видеореклама',
  TAB_VIDEO_STREAMS: 'Видеоволны',
};
